import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  actions,
  selectors,
} from '../../store/dux/field-boundary-management-dux';
import Confirmation from './CertifyConfirmation';
import Results from './ValidationResults';

export function CertifyFields(props) {
  const dispatch = useDispatch();
  const results = useSelector(selectors.certificationResults);

  useEffect(() => {
    dispatch(actions.clearResults());
  }, [dispatch]);

  return results ? (
    <Results
      validationResults={results}
      handleClose={props.close}
      dialogMode="CERTIFY"
    />
  ) : (
    <Confirmation
      fields={props.fields}
      handleClose={props.close}
      handleCertified={handleCertified}
    />
  );

  async function handleCertified(certifyResults) {
    dispatch(actions.fieldsCertified(certifyResults));
  }
}
